import { CourseCart, LiffData } from '@/type/Course'
import { pickTranslated } from '@/utils/i18nContent'

/**
 * ชื่อคอร์สที่แอดมินตั้งไว้ ตามภาษาที่ผู้ใช้เลือก (fallback cn -> en -> th) - LMP-6907
 *
 * สำคัญ: ห้ามเอาค่าที่ได้จากฟังก์ชันนี้ไปเขียนทับ `liff_data.display_name` หรือ `CourseCart.name`
 * ทั้งสองตัวนั้นต้องคงเป็นภาษาไทยเสมอ เพราะ CourseCheckout.validateExistingCourse() ใช้เทียบว่า
 * คอร์สถูกแก้ไขหรือยัง - ถ้าเก็บคำแปลลงไป ผู้ใช้ EN/CN จะเจอ dialog "คอร์สมีการเปลี่ยนแปลง" ทุกครั้ง
 * ฟังก์ชันนี้ใช้ตอน "แสดงผล" เท่านั้น
 */
export const getCourseDisplayNamei18n = (
  liffData: Pick<LiffData, 'display_name' | 'display_name_en' | 'display_name_cn'> | undefined | null,
  lang: string,
): string => pickTranslated(liffData?.display_name, liffData?.display_name_en, liffData?.display_name_cn, lang)

/**
 * เวอร์ชันสำหรับรายการในตะกร้า - ตะกร้าเก็บ `name` เป็นสตริงไทยแบนๆ (และ persist ลง localStorage)
 * จึงต้องอ่านคำแปลจาก `detail.liff_data` แทน แล้ว fallback กลับไปที่ `name` ถ้าตะกร้าเก่าไม่มี detail
 */
export const getCartItemDisplayNamei18n = (item: CourseCart, lang: string): string =>
  getCourseDisplayNamei18n(item.detail?.liff_data, lang) || item.name
